import React, { Component } from "react"
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap"
import OrderResultRecord from "../../api/OrderResults/OrderResultModel/OrderResultRecord"
import { toast } from "react-toastify"
import printPdf from "../../utils/printPdf"
import FormatError from "../../formatters/FormatError"
import { EmailRegexp, PhoneRegexp } from "../../config/Constants"
import PhoneNumberMaskedInput from "../FormattedInputs/PhoneNumberMaskedInput"
import ActionButton from "../ActionButton"
import { FaMinus, FaPlus } from "react-icons/fa"
import { Subscription } from "rxjs"
import { AppState } from "../../AppState"
import { connect } from "react-redux"
import { BuildUserAccess } from "../../authentication/BuildUserAccess"
import { GetSSOToken } from "../../storage/AuthToken"
import { FullBaseUrl } from "../../api/ApiUrl"
import SendSelectClinicLinkParams from "../../api/OrderResults/OrderResultModel/SendSelectClinicLinkParams"
import SendSelectClinicLinkObservable from "../../api/OrderResults/SendClinicSelectLink"


interface SendSelectClinicLinkProps {
  details?: OrderResultRecord
  onHide: () => void
  onEdit?: (data: OrderResultRecord) => void
  isAfterUpdate?: boolean
}


interface SendSelectClinicLinkState {
  emailItems: string[]
  email: string
  sendingEmail: boolean
}

export default class SendSelectClinicLink extends Component<SendSelectClinicLinkProps, SendSelectClinicLinkState> {
  state: SendSelectClinicLinkState = {
    emailItems: [""],
    email: "",
    sendingEmail: false
  }

  loadSubscription?: Subscription

  componentWillUnmount() {
    this.loadSubscription && this.loadSubscription.unsubscribe()
  }

 


  changeEmail = (email: string) => {
    this.setState({ email: email || "" })
  }

  sendEmail = () => {
    const email = this.state.email || ""
    if (!this.isEmailValid(email)) {
      toast.error("Please enter valid email address.")
      return
    }

    let formFoxTestAN = parseInt(this.props.details?.FormFoxTestAN || "0")
    if (isNaN(formFoxTestAN)) {
      formFoxTestAN = 0
    }
    
    let accountID = 0
    if(this.props.details?.CompanyID){
      accountID = parseInt(this.props.details?.CompanyID.toString())
    }
    if (isNaN(accountID)) {
      accountID = 0
    }

    let testDetailID = 0
    if(this.props.details?.TestDetailID){
      testDetailID = parseInt(this.props.details?.TestDetailID.toString())
    }
    if (isNaN(testDetailID)) {
      testDetailID = 0
    }
    let testDetailClinicalID = 0
    if(this.props.details?.TestDetailClinicalID){
      testDetailClinicalID = parseInt(this.props.details?.TestDetailClinicalID.toString())
    }
    if (isNaN(testDetailClinicalID)) {
      testDetailClinicalID = 0
    }
    const params: SendSelectClinicLinkParams = {
      FormFoxTestAN: formFoxTestAN,
      ApiRequestToken: "",
      BaseUrl: FullBaseUrl(),
      AccountID: accountID,
      Email: email,
      MarketplaceAuthNum: this.props.details?.MarketPlaceOrderNum || "",
      PersonID: this.props.details?.PersonID || 0,
      TestReason: this.props.details?.Reason || "",
      TestDetailID: this.props.details?.TestDetailID || "",
      TestDetailClinicalID: this.props.details?.TestDetailClinicalID || ""
    }
    this.loadSubscription && this.loadSubscription.unsubscribe()
    this.setState({ sendingEmail: true })
    this.loadSubscription = SendSelectClinicLinkObservable(params).subscribe(
      data => {
        toast.success("Email sent successfully")
        this.setState({ sendingEmail: false })
        this.props.onHide()
      },
      error => {
        toast.error(FormatError(error))
        this.setState({ sendingEmail: false })
      }
    )

  }

  isEmailValid = (value: string): boolean => {
    if (value.length === 0) {
      return false
    }
    return EmailRegexp.test(value)
  }



  render() {
    const { sendingEmail, email } = this.state
    const { details, onHide } = this.props
    return (
      <Modal show onHide={onHide} size="lg" dialogClassName="dark">
        <Modal.Header closeButton>
          <Modal.Title>
            {<h4 className="text-uppercase"><span>Resend Email (Authorization #{details?.FormFoxTestAN})</span></h4>}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          <Container fluid>
            {<Row className="pt-2" key={`donor_email`}>
              <Col xs={14} sm={4} md={4} lg={3}>
                {"Donor Email:"}
              </Col>
              <Col>
                <Form.Control size="sm" name="email_address" maxLength={40} type="text" value={email} onChange={(e) => this.changeEmail(e.target.value)} isInvalid={!this.isEmailValid(email)} />
              </Col>
            </Row>
            }
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <ActionButton size="sm" className="fixed-w10" onClick={this.sendEmail} disabled={!this.isEmailValid(email) || sendingEmail} spin={sendingEmail}>Send Email</ActionButton>
          <Button variant="secondary" size="sm" onClick={onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

